module.exports = __webpack_public_path__ + "static/media/get-recommendations-mobile-es.bccdb0ed.webp";